import stores from '../assets/stores.json'
import { getClaims } from './authService'

export function getStores() {
  return stores
}

export async function getStoresProtected() {
  const claims = await getClaims()

  switch (claims.role) {
    case 'moderator':
      return stores.filter((s) => claims.stores.includes(s.id))
    case 'admin':
      return stores
    default:
      return []
  }
}

export async function getStoresProtectedAmazon() {
  const claims = await getClaims()

  switch (claims.role) {
    case 'moderator':
      return stores.filter((s) => claims.stores.includes(s.id) && s.amazon)
    case 'admin':
      return stores.filter((s) => s.amazon)
    default:
      return []
  }
}

export async function getStoreById(id) {
  const stores = await getStoresProtected()
  const store = stores.find((s) => s.id.toUpperCase() === id.toUpperCase())

  if (!store) throw Error(`Could not find store with id ${id}`)
  return store
}
